import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Spinner, Table } from "reactstrap";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Container from "../../../components/Container";
import AppLayout from "../../../components/layouts/AppLayout";
import API from "../../../utils/API";
import Create from "./Create";
import Delete from "./Delete";
import Edit from "./Edit";

const Index = () => {
  const [campuses, setCampuses] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchCampuses = async () => {
    try {
      const data = (await API.get("/api/campuses")).data.data;
      setCampuses(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCampuses();
  }, [refresh]);

  return (
    <AppLayout>
      <Breadcrumbs
        title="Campuses"
        links={[
          {
            title: "Dashboard",
            link: null,
          },
          {
            title: "Campuses",
            link: null,
          },
        ]}
      />
      <Container>
        <Card className="border-0 shadow mt-5" style={{ minHeight: "70vh" }}>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h1 className="mb-0">All Campuses</h1>
              <Create campuses={campuses} fetchCampuses={fetchCampuses} />
            </div>
            <Table hover responsive>
              <thead>
                <tr className="bg-shade-blue">
                  <th>#</th>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Email</th>
                  <th>Address</th>
                  <th>Contact Number</th>
                  <th>Fax</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {campuses.length > 0 ? (
                  campuses.map((campuses, index) => (
                    <tr
                      key={`campuses-${campuses.id}`}
                      style={{ verticalAlign: "middle" }}>
                      <th scope="row">{index + 1}</th>
                      <td>{campuses.name}</td>
                      <td>{campuses.type}</td>
                      <td>{campuses.email}</td>
                      <td>{campuses.address}</td>
                      <td>{campuses.contact_number}</td>
                      <td>{campuses.fax}</td>
                      <td>
                        <Edit
                          campuses={campuses}
                          fetchCampuses={fetchCampuses}
                        />

                        <Delete
                          campuses={campuses}
                          refresh={refresh}
                          setRefresh={setRefresh}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">
                      {loading ? (
                        <Spinner style={{ width: "30px", height: "30px" }} />
                      ) : (
                        "No Campuses Exists"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
    </AppLayout>
  );
};

export default Index;
